import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'src/pages/authentication/i18n';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from 'material-hu';

export type NewCommunityConfirmationProps = {
  open: boolean;
  onCancel: () => void;
};

const NewCommunityConfirmation: FC<NewCommunityConfirmationProps> = (props) => {
  const {
    open,
    onCancel,
  } = props;

  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleNewCommunity = () => navigate('/new');

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth='xs'
    >
      <DialogTitle sx={{ py: 3 }}>
        <Typography sx={{ fontSize: '22px', fontWeight: 600, textAlign: 'center', px: 4 }}>
          {t('NEW_COMMUNITY_CONFIRMATION_TITLE')}
        </Typography>

      </DialogTitle>
      <DialogContent sx={{ pb: 3, px: 4 }}>
        <Typography color="secondary" sx={{ textAlign: 'center' }}>
          {t('NEW_COMMUNITY_CONFIRMATION_DESCRIPTION')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ display: 'block', pb: 3, px: 4 }}>
        <Button
          variant="contained"
          onClick={onCancel}
          fullWidth
          sx={{ py: 1 }}
        >
          {t('GO_BACK_TO_LOGIN_MENU')}
        </Button>
        <Button
          onClick={handleNewCommunity}
          fullWidth
          sx={{ color: '#9E9E9E', mt: 2, py: 1, marginLeft: '0px !important' }}
        >
          {t('GO_TO_NEW_COMMUNITY_FORM')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewCommunityConfirmation;
